import { useState, useRef, useEffect } from 'react';
import './Menu.scss';

function Menu({ trigger, items = [], align = 'left', className = '' }) {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  // Close on outside click
  useEffect(() => {
    if (!isOpen) return;
    const handleClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [isOpen]);

  // Close on Escape
  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e) => {
      if (e.key === 'Escape') setIsOpen(false);
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [isOpen]);

  return (
    <div className={`menu ${className}`} ref={menuRef}>
      <div className="menu__trigger" onClick={() => setIsOpen(!isOpen)}>
        {trigger}
      </div>
      <div
        className={`menu__dropdown ${isOpen ? 'menu__dropdown--open' : ''} ${
          align === 'right' ? 'menu__dropdown--right' : ''
        }`}
      >
        {items.map((item, i) => {
          if (item.divider) {
            return <div key={i} className="menu__divider" />;
          }
          return (
            <button
              key={i}
              className={`menu__item ${item.active ? 'menu__item--active' : ''} ${
                item.danger ? 'menu__item--danger' : ''
              }`}
              onClick={() => {
                item.onClick?.();
                setIsOpen(false);
              }}
            >
              {item.icon && <span className="menu__item-icon">{item.icon}</span>}
              {item.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default Menu;
